import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  serviceCenterDefaultValues,
  serviceCenterResolver,
} from '../consts/diagnosticDrawer.consts'
import { createServiceRequestStore } from '../stores/NewCreateServiceRequestStore'
import { ServiceCenterForm } from '../types/NewDrawers.types'
export const useCheckServiceForm = () => {
  const { isServerOrdersDrawerOpen, serviceCenterData, fromExistedRequest } =
    createServiceRequestStore

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { isValid, errors },
  } = useForm<ServiceCenterForm>({
    mode: 'onChange',
    defaultValues: serviceCenterDefaultValues,
    resolver: serviceCenterResolver,
  })

  useEffect(() => {
    if (
      serviceCenterData?.serialNumber &&
      isServerOrdersDrawerOpen &&
      fromExistedRequest
    ) {
      setValue('serialNumber', serviceCenterData?.serialNumber)
    } else if (!serviceCenterData?.serialNumber) {
      setValue('serialNumber', '')
    }
  }, [
    serviceCenterData?.serialNumber,
    isServerOrdersDrawerOpen,
    fromExistedRequest,
  ])

  const onReset = () => reset(serviceCenterDefaultValues)

  return { onReset, watch, setValue, handleSubmit, control, isValid, errors }
}
